import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
import { loadFont as loadOutfit } from "@remotion/google-fonts/Outfit";
import { loadFont as loadSpaceGrotesk } from "@remotion/google-fonts/SpaceGrotesk";
import { loadFont as loadJetBrainsMono } from "@remotion/google-fonts/JetBrainsMono";
import { loadFont as loadPlayfairDisplay } from "@remotion/google-fonts/PlayfairDisplay";
import { loadFont as loadAnton } from "@remotion/google-fonts/Anton";
import { loadFont as loadOrbitron } from "@remotion/google-fonts/Orbitron";
// --- New fonts for 10 new templates ---
import { loadFont as loadCormorantGaramond } from "@remotion/google-fonts/CormorantGaramond";
import { loadFont as loadDMSans } from "@remotion/google-fonts/DMSans";
import { loadFont as loadCinzel } from "@remotion/google-fonts/Cinzel";
import { loadFont as loadBebasNeue } from "@remotion/google-fonts/BebasNeue";
import { loadFont as loadIBMPlexMono } from "@remotion/google-fonts/IBMPlexMono";
import { loadFont as loadNunito } from "@remotion/google-fonts/Nunito";
import { loadFont as loadPacifico } from "@remotion/google-fonts/Pacifico";
import { loadFont as loadPlusJakartaSans } from "@remotion/google-fonts/PlusJakartaSans";
import { loadFont as loadRajdhani } from "@remotion/google-fonts/Rajdhani";
import { loadFont as loadShareTechMono } from "@remotion/google-fonts/ShareTechMono";
import { loadFont as loadJosefinSans } from "@remotion/google-fonts/JosefinSans";
import { loadFont as loadSourceSerif4 } from "@remotion/google-fonts/SourceSerif4";
import { loadFont as loadLibreBaskerville } from "@remotion/google-fonts/LibreBaskerville";
import { loadFont as loadSpecialElite } from "@remotion/google-fonts/SpecialElite";
import { loadFont as loadBarlowCondensed } from "@remotion/google-fonts/BarlowCondensed";
import { loadFont as loadOswald } from "@remotion/google-fonts/Oswald";
import { loadFont as loadNotoSerifJP } from "@remotion/google-fonts/NotoSerifJP";
import { loadFont as loadLato } from "@remotion/google-fonts/Lato";

/**
 * 🌐 Programmatic Google Fonts Registry via @remotion/google-fonts
 * Registers all Google Fonts programmatically using official Remotion packages.
 * Remotion automatically blocks compilation/frame rendering until these fonts
 * are fully ready, ensuring zero FOUT (flash of unstyled text) or layout shifts.
 *
 * Total: 25 font families covering all 18 templates.
 */
export const registerGoogleFonts = () => {
  console.log(
    "🌐 [Fonts] Loading Google Fonts programmatically via @remotion/google-fonts...",
  );

  // ── Original 8 Templates ──────────────────────────────────────────────────

  // 1. Anton (Kinetic Flash)
  loadAnton("normal", { weights: ["400"], subsets: ["latin"] });

  // 2. Inter (Minimal Glass & CTA defaults)
  loadInter("normal", {
    weights: ["300", "400", "500", "600", "700", "800", "900"],
    subsets: ["latin"],
  });

  // 3. Space Grotesk (Bold Creator, Cyber takeaway & Geometric Liquid)
  loadSpaceGrotesk("normal", {
    weights: ["500", "600", "700"],
    subsets: ["latin"],
  });

  // 4. JetBrains Mono (Retro Terminal)
  loadJetBrainsMono("normal", {
    weights: ["400", "700", "800"],
    subsets: ["latin"],
  });

  // 5. Playfair Display (Editorial Cream Serif)
  loadPlayfairDisplay("normal", {
    weights: ["400", "700"],
    subsets: ["latin"],
  });
  loadPlayfairDisplay("italic", { weights: ["400"], subsets: ["latin"] });

  // 6. Orbitron (Neon Synthwave + Spatial Three)
  loadOrbitron("normal", {
    weights: ["500", "700", "900"],
    subsets: ["latin"],
  });

  // 7. Outfit (Cyber-HUD & Kinetic Type)
  loadOutfit("normal", {
    weights: ["500", "700", "800", "900"],
    subsets: ["latin"],
  });

  // ── New 10 Templates ─────────────────────────────────────────────────────

  // 8. Cormorant Garamond (Aurora Nature headings + Luxury Gold headings)
  loadCormorantGaramond("normal", {
    weights: ["400", "600"],
    subsets: ["latin"],
  });
  loadCormorantGaramond("italic", {
    weights: ["400", "600"],
    subsets: ["latin"],
  });

  // 9. DM Sans (Aurora Nature body)
  loadDMSans("normal", { weights: ["400", "500", "700"], subsets: ["latin"] });

  // 10. Cinzel (Luxury Gold accent labels)
  loadCinzel("normal", { weights: ["400", "700"], subsets: ["latin"] });

  // 11. Bebas Neue (Urban Street display)
  loadBebasNeue("normal", { weights: ["400"], subsets: ["latin"] });

  // 12. IBM Plex Mono (Urban Street data/captions)
  loadIBMPlexMono("normal", { weights: ["400", "700"], subsets: ["latin"] });

  // 13. Nunito (Pastel Pop playful)
  loadNunito("normal", {
    weights: ["400", "700", "800", "900"],
    subsets: ["latin"],
  });

  // 14. Pacifico (Pastel Pop accent title)
  loadPacifico("normal", { weights: ["400"], subsets: ["latin"] });

  // 15. Plus Jakarta Sans (Corporate Pro headings)
  loadPlusJakartaSans("normal", {
    weights: ["400", "600", "700", "800"],
    subsets: ["latin"],
  });

  // 16. Rajdhani (Cyberpunk 2099 angular display)
  loadRajdhani("normal", {
    weights: ["400", "600", "700"],
    subsets: ["latin"],
  });

  // 17. Share Tech Mono (Cyberpunk 2099 terminal data)
  loadShareTechMono("normal", { weights: ["400"], subsets: ["latin"] });

  // 18. Josefin Sans (Ocean Depths geometric labels)
  loadJosefinSans("normal", {
    weights: ["400", "600", "700"],
    subsets: ["latin"],
  });

  // 19. Source Serif 4 (Ocean Depths body)
  loadSourceSerif4("normal", { weights: ["400", "600"], subsets: ["latin"] });
  loadSourceSerif4("italic", { weights: ["400", "600"], subsets: ["latin"] });

  // 20. Libre Baskerville (Vintage Film classic book)
  loadLibreBaskerville("normal", {
    weights: ["400", "700"],
    subsets: ["latin"],
  });
  loadLibreBaskerville("italic", { weights: ["400"], subsets: ["latin"] });

  // 21. Special Elite (Vintage Film typewriter)
  loadSpecialElite("normal", { weights: ["400"], subsets: ["latin"] });

  // 22. Barlow Condensed (Sports Energy bold compressed)
  loadBarlowCondensed("normal", {
    weights: ["400", "600", "700", "800", "900"],
    subsets: ["latin"],
  });
  loadBarlowCondensed("italic", {
    weights: ["700", "900"],
    subsets: ["latin"],
  });

  // 23. Oswald (Sports Energy stats display)
  loadOswald("normal", { weights: ["400", "600", "700"], subsets: ["latin"] });

  // 24. Noto Serif JP (Zen Minimal Japanese elegance)
  loadNotoSerifJP("normal", { weights: ["400", "700"], subsets: ["latin"] });

  // 25. Lato (Zen Minimal clean body)
  loadLato("normal", { weights: ["300", "400", "700"], subsets: ["latin"] });
  loadLato("italic", { weights: ["300", "400"], subsets: ["latin"] });

  console.log(
    "✨ [Fonts] 25 Google Font families loaded successfully via @remotion/google-fonts!",
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
